<template>
  <a-card :bordered="false">
    <div>
      <div class="tip-wrap">
        <i class="el-icon-s-opportunity" aria-hidden="true"></i>
        请为不同字典项目添加不同字典编码
      </div>
      <div :key="row.id" v-for="row in table.data">
        <div class="detail-item-wrap">
          <div class="detail-type">
            {{ row.code }}
            <div class="detail-operation">
              <i class="el-icon-top" @click="upSysDictData(row.id)"></i>
              <i class="el-icon-bottom" @click="downSysDictData(row.id)"></i>
              <i class="fa fa-pencil-square-o" aria-hidden="true"
                 @click="editSysDictData(row.id)"></i>
              <i class="fa fa-times" aria-hidden="true"
                 @click="deleteSysDictData(row.id)"
              ></i>
            </div>
          </div>
          <div>{{ row.name }}</div>
        </div>
      </div>
      <a-button
        type="block"
        class="dashed-button"
        style="height: 34px"
        @click="addSysDictData">添加数据
      </a-button>
    </div>
    <a-modal :footer="null"
             title="提示"
             append-to-body
             v-model="form.visible">
      <sysDictData-edit
        v-if="form.visible"
        :sys-dict-id="sysDictId"
        :sys-dict-data-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </sysDictData-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _querySysDictData,
  _deleteSysDictData,
  _upSysDictData,
  _downSysDictData,
} from '@/api/sys/sysDictDataApi';
import SysDictDataEdit from './SysDictDataEdit.vue';

async function getSysDictDataList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _querySysDictData(
    this.sysDictId,
    {
      sort: 'sort',
      direction,
    },
  );
  this.table.data = result.content;
}

function addSysDictData() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editSysDictData(sysDictDataId) {
  this.form.data.id = sysDictDataId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getSysDictDataList();
}

async function deleteSysDictData(sysDictDataId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      const result = await _deleteSysDictData(this.sysDictId, sysDictDataId);
      if (result) {
        this.$message.success(this.$t('REMOVE_SUCCESS'));
        this.getSysDictDataList();
      }
    },
  });
}

async function upSysDictData(sysDictDataId) {
  this.$confirm({
    title: '是否上移菜单？',
    content: '',
    onOk: async () => {
      await _upSysDictData(this.sysDictId, sysDictDataId);
      this.$message.success('上移成功');
      this.getSysDictDataList();
    },
  });
}

async function downSysDictData(sysDictDataId) {
  this.$confirm({
    title: '是否下移菜单？',
    content: '',
    onOk: async () => {
      await _downSysDictData(this.sysDictId, sysDictDataId);
      this.$message.success('下移成功');
      this.getSysDictDataList();
    },
  });
}

export default {
  name: 'SysDictDataList',
  components: { SysDictDataEdit },
  props: {
    sysDictId: String,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'ascend',
        },
      },
    };
  },
  methods: {
    getSysDictDataList,
    deleteSysDictData,
    editSysDictData,
    addSysDictData,
    closeForm,
    upSysDictData,
    downSysDictData,
  },
  created() {
    this.getSysDictDataList();
  },
};
</script>

<style scoped>
.detail-item-wrap {
  border: 1px solid #eeeeee;
  border-left: 3px solid #2f4669;
  padding: 10px;
  line-height: 20px;
  color: #909399;
  margin: 10px 0;
}

.detail-operation {
  display: none;
  float: right;
  padding-right: 5px;
}

.detail-item-wrap:hover .detail-operation {
  display: block;
}

.detail-operation i {
  cursor: pointer;
  padding: 0 5px;
  font-size: 14px;
  color: #2f4669;
}

.detail-type {
  border-bottom: 1px solid #eeeeee;
  color: #000000;
}
</style>
